import { render, staticRenderFns } from "./PhotoAttachmentPicker.vue?vue&type=template&id=681a75a0&scoped=true"
import script from "./PhotoAttachmentPicker.vue?vue&type=script&lang=ts"
export * from "./PhotoAttachmentPicker.vue?vue&type=script&lang=ts"
import style0 from "./PhotoAttachmentPicker.vue?vue&type=style&index=0&id=681a75a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a75a0",
  null
  
)

export default component.exports